<script lang="ts" setup>
interface Props {
  duration?: 100 | 300;
}

const props = withDefaults(defineProps<Props>(), {
  duration: 300,
});

const durationClass = props.duration === 300 ? 'duration-300' : 'duration-[100ms]';
</script>

<template>
  <transition
    :enter-active-class="`${durationClass} ease-in transition-opacity`"
    enter-from-class="transform opacity-0"
    enter-to-class="opacity-100"
    :leave-active-class="`${durationClass} ease-in`"
    leave-from-class="opacity-100"
    leave-to-class="transform opacity-0"
    mode="out-in"
  >
    <slot />
  </transition>
</template>
